import './VideoPlayer.css'
import * as React from "react";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {CircularProgress} from "@mui/material";
import DownloadLimitExceededPopup from "../../../../Components/DownloadLimit/DownloadLimitExceededPopup";
import FullScreenPopup from "../../../../Components/FullScreenPopup/FullScreenPopup";
import VideoDownloadButton from "./VideoDownloadButton";

class VideoPlayer extends React.Component {
  state = {
    loading: false,
    limitExceeded: false
  }

  play() {
    this.setState({loading: true});

    grecaptcha.ready(function () {
      grecaptcha.execute(recaptchaKey, {action: 'submit'}).then(
        function (token) {
          fetch(`/api/videos/${this.props.videoId}/${this.props.part}/preview`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Captcha-Token': token
            },
            body: JSON.stringify(this.details)
          })
            .then(response => {
              if (response.ok) {
                return response.text();
              } else {
                throw new Error(response.status.toString())
              }
            })
            .then(url => {
              this.setState({previewUrl: url, loading: false, limitExceeded: false});
            })
            .catch(reason => {
              if (reason.message === "401") {
                this.setState({limitExceeded: true, loading: false, previewUrl: null});
              }
            });
        }.bind(this));
    }.bind(this));
  }

  handleClose() {
    this.setState({limitExceeded: false});
  }

  closePlayer() {
    this.setState({previewUrl: null});
  }

  render() {
    return (
      <div className="video-player-wrapper">
        {
          this.state.previewUrl
            ?
            <FullScreenPopup open={!!this.state.previewUrl} onClose={this.closePlayer.bind(this)} title={"Watch: " + this.props.name}>
              <div className="video-iframe-wrapper">
                <div className="video-iframe-overlay">
                  <VideoDownloadButton variant="icon" videoId={this.props.videoId} part={this.props.part} fileName={this.props.fileName} />
                </div>
                <iframe title={this.props.name} className="video-iframe" src={this.state.previewUrl} frameBorder={0} allow="autoplay; fullscreen;" />
                <div className="video-iframe-loading">
                  <CircularProgress />
                </div>
              </div>
            </FullScreenPopup>
            :
            <div className={"video-player-cover"} style={this.props.thumbnail ? {backgroundImage: `URL(${this.props.thumbnail})`} : {}} onClick={this.play.bind(this)}>
              <div className={"video-player-button"}>
                {this.state.loading ? <CircularProgress color={"inherit"} /> : <PlayArrowIcon fontSize={"inherit"} />}
              </div>
            </div>
        }
        <DownloadLimitExceededPopup open={this.state.limitExceeded} action="watch online or download" mediaType="videos" onClose={this.handleClose.bind(this)} />
      </div>
    );
  }
}

export default VideoPlayer;
